<template>
    <draggable
        v-bind="dragOptions"
        class="pb-1"
        :list="treeItems"
        :group="{
            name: 'layers-tree',
            pull: true
        }"
        :move="handleMove"
        @change="onChange"
    >
        <template v-if="treeItems && treeItems.length">
            <c-lazy v-for="(treeItem, index) in treeItems" :key="getItemKey(treeItem)">
                <layers-tree-item v-model="treeItems[index]" @tree-item-moved="layerTreeItemMove" />
            </c-lazy>
        </template>
        <template v-else>
            <div class="no-children">This is empty</div>
        </template>
    </draggable>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import draggable from 'vuedraggable';
import store from '@/store';

import LayersTreeItem from './item/LayersTreeItem.vue';
import CLazy from '@/components/CLazy.vue';
import { useLayersDraggable } from '@/components/Layers/composables/layerDraggable';

const { dragOptions, handleMove, getItemKey, handleChange } = useLayersDraggable();

const emit = defineEmits<{
    (event: 'tree-item-moved'): void;
}>();

const treeItems = computed({
    get: () => store.state.storeLayers?.treeItems || [],
    set: (value) => store.dispatch('storeLayers/setTreeItems', value)
});

const onChange = () => {
    handleChange();
};

const layerTreeItemMove = () => {
    emit('tree-item-moved');
};
</script>

<style scoped>
.no-children {
    color: #999;
    font-style: italic;
    text-align: center;
    padding: 0.5rem;
}
</style>
